// frontend/src/components/ActiveFiltersDisplay.jsx
export default function ActiveFiltersDisplay({ filters, onRemove, onClearAll }) {
  const labelMap = {
    q: "Query",
    country: "Country",
    status: "Status",
    risk_level: "Risk",
    residency_status: "Residency",
    legal_form: "Legal Form",
    country_id: "Country",
    managed_by: "Managed by",
    services: "Services",
    transaction_types: "Transaction Types",
    business_activity: "Activity",
    bank_account: "Bank Account",
    has_documents: "Has Documents",
    started_from: "Relationship From",
    started_to: "Relationship To",
    review_status: "Review",
    coc_status: "CoC",
    screening_status: "Screening",
    license_status: "License",
    created_within: "Created Within",
    updated_within: "Updated Within",
  };

  const valueMap = {
    risk_level: { low: "Low", medium: "Medium", high: "High", very_high: "Very High" },
    status: { active: "Active", pending_gov_approval: "Pending", liquidated: "Liquidated", rejected: "Rejected" },
    residency_status: { local: "Local", international: "International", foreign: "Foreign" },
    managed_by: { gtrust: "G-Trust Curaçao B.V.", prostaff: "ProStaff Curacao N.V." },
    bank_account: { 1: "Yes", 0: "No", true: "Yes", false: "No" },
    has_documents: { 1: "Yes", 0: "No", true: "Yes", false: "No" },
    review_status: { current: "Current", due_soon: "Due Soon", overdue: "Overdue", never_reviewed: "Never Reviewed" },
    coc_status: { current: "Current", due_soon: "Due Soon", overdue: "Overdue", no_record: "No Record" },
    screening_status: { clean: "Clean", hits: "Hits", outdated: "Outdated" },
    license_status: { current: "Current", expiring_soon: "Expiring Soon", expired: "Expired" },
  };

  const chips = [];

  Object.entries(filters || {}).forEach(([key, value]) => {
    if (key === "page" || key === "pageSize" || key === "type") return;
    if (!value || (Array.isArray(value) && value.length === 0)) return;

    const label = labelMap[key] || key;

    if (Array.isArray(value)) {
      value.forEach((v) => {
        if (v === undefined || v === null || v === "") return;
        const displayValue = valueMap[key]?.[v] || v;
        chips.push({
          key: `${key}-${v}`,
          label: `${label}: ${displayValue}`,
          onRemove: () => onRemove(key, v),
        });
      });
    } else {
      const displayValue = valueMap[key]?.[value] || value;
      chips.push({
        key,
        label: `${label}: ${displayValue}`,
        onRemove: () => onRemove(key, value),
      });
    }
  });

  if (chips.length === 0) return null;

  return (
    <div
      style={{
        padding: "12px 16px",
        borderRadius: 8,
        background: "rgba(59, 130, 246, 0.08)",
        border: "1px solid rgba(59, 130, 246, 0.2)",
        marginBottom: 16,
      }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
        <span style={{ fontSize: 13, fontWeight: 600, color: "var(--text-secondary)" }}>Active Filters:</span>

        {chips.map((chip) => (
          <div
            key={chip.key}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              padding: "4px 10px",
              borderRadius: 999,
              background: "rgba(59, 130, 246, 0.15)",
              border: "1px solid rgba(59, 130, 246, 0.3)",
              color: "var(--accent-primary)",
              fontSize: 13,
              fontWeight: 600,
            }}>
            <span>{chip.label}</span>
            <button
              onClick={chip.onRemove}
              type="button"
              style={{
                width: 18,
                height: 18,
                display: "grid",
                placeItems: "center",
                borderRadius: 999,
                background: "transparent",
                border: "none",
                color: "var(--accent-primary)",
                cursor: "pointer",
                fontSize: 14,
              }}
              onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(59, 130, 246, 0.2)")}
              onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}>
              ✕
            </button>
          </div>
        ))}

        <button
          type="button"
          onClick={onClearAll}
          style={{
            marginLeft: 8,
            background: "none",
            border: "none",
            color: "var(--accent-primary)",
            fontSize: 13,
            fontWeight: 700,
            cursor: "pointer",
            textDecoration: "underline",
          }}>
          Clear All
        </button>
      </div>
    </div>
  );
}
